import { Box, SimpleGrid } from "@chakra-ui/react";
import { Grid } from "modules/common/components/Grid";
import type { BestRatedProps } from "../SelectDate/types";
import { BestByCountry } from "./BestByCountry";
import { BestByRegion } from "./BestByRegion";

export const BestRated = ({ bestByCountry, bestByRegion, scoresType }: BestRatedProps) => (
  <Box bg="greyscale.300" pb={{ base: 0, lg: 20 }}>
    <Grid mb={0} px={{ base: "unset", lg: 4, xl: "unset" }}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }}>
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={{ base: 0, lg: 8 }}>
          <BestByCountry bestByCountry={bestByCountry} scoresType={scoresType} />
          <BestByRegion regionScore={bestByRegion} scoresType={scoresType} />
        </SimpleGrid>
      </Box>
    </Grid>
  </Box>
);
